<div *ngIf="!loading">
  <div class="search-bar">
    <label for="carrierName">Filter by Carrier name</label>
    <input
      id="carrierName"
      name="carrier-name"
      class="pure-input-2-3"
      type="text"
      [(ngModel)]="carrierName"
      placeholder="Enter carrier name"
      (keyup)="findByCarrierName()"
    />
  </div>
  <table class="pure-table pure-table-horizontal">
    <thead>
      <tr>
        <th>Requester</th>
        <th>
          UI page
          <i
            class="fa fa-info-circle ui-page-info-icon"
            placement="right"
            [ngbPopover]="uiPageTooltip"
            triggers="mouseenter:mouseleave"
          >
          </i>
        </th>
        <th>Business unit</th>
        <th>Component key values</th>
        <th>Transit Time type</th>
        <th class="request-reason">Request Reason</th>
        <th>Status</th>
        <th>Date</th>
      </tr>
    </thead>
    <tbody *ngIf="requestedResourcePermissions?.length != 0">
      <tr *ngFor="let row of requestedResourcePermissions">
        <td>
          {{ row?.actorId }}
        </td>
        <td>
          <ul *ngFor="let view of row?.views">
            <li>
              {{ viewLabels[view] }}
            </li>
          </ul>
        </td>
        <td>
          {{ row?.businessUnit }}
        </td>
        <td>
          <ul *ngFor="let componentKeyValue of row?.componentKeyValues">
            <li *ngIf="componentKeyValue?.length">
              {{ componentKeyValue.join(":") }}
            </li>
          </ul>
        </td>
        <td>
          {{ row?.transitTimeType }}
        </td>
        <td>
          {{ row?.requestReason }}
        </td>
        <td>
          {{ row?.requestStatus }}
        </td>
        <td>
          {{ row?.requestTimestamp | date }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
<ng-template #uiPageTooltip>
  <div class="ui-page-tooltip">
    <div class="tooltip-section">
      <strong>{{ viewLabels.can_view }}</strong>
      <ul>
        <li>Download Reports</li>
        <li>View History</li>
      </ul>
    </div>
    <div class="tooltip-section">
      <strong>{{ viewLabels.can_edit }}</strong>
      <ul>
        <li>UPDATE TRANSIT TIME</li>
        <li>UPDATE VALIDATION THRESHOLD</li>
        <li>ADD/REMOVE OVERRIDES</li>
        <li>SWITCH TRANSIT TIME TYPE</li>
      </ul>
    </div>
    <div class="tooltip-section">
      <strong>{{ viewLabels.can_review }}</strong>
      <ul>
        <li>Pending Approval Requests</li>
      </ul>
    </div>
  </div>
</ng-template>
<app-loader [loading]="loading" [size]="'small'"></app-loader>